class SmiffysAdditionalProductsPopupHelper {
    async additionalProductsButtonClicked(event) {
        event.preventDefault();
        let target = event.target;
        let productHandle = target.getAttribute('data-productHandle');
        let additionalProductType = target.getAttribute('data-additionalProductType');
        target.setAttribute('disabled', 'disabled');
        try {
            await this.showAdditionalProductPopup(productHandle, additionalProductType);
        } finally {
            target.removeAttribute('disabled');
        }
    }
    async getProductData(url) {
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        return await fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => JSON.parse(result))
            .catch(error => console.log('error', error));
    }

    async populateFromUrl(url) {
        smiffysAdditionalProductsPopupModal.setContent();
        smiffysAdditionalProductsPopupModal.open("Loading Products");
        const pd = await this.getProductData(url);
        if (pd == null) {
            popup.setStatus('This item is not currently available in your territory');
            return;
        }
        if (pd.tableHtml) {
            smiffysAdditionalProductsPopupModal.setContent(pd.tableHtml);
            smiffysAdditionalProductsPopupModal.setStatus('');
            if (window.spark) {
                SmiffysCartQuantityLoader.getCartAndUpdateUi();
            }
        }
    }

    async showAdditionalProductPopup(productHandle, additionalProductType) {
        switch (additionalProductType) {
            case "CompleteTheLook": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=completethelook`;
                await this.populateFromUrl(url);
                break;
            }
            case "RelatedProducts": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=relatedproducts`;
                await this.populateFromUrl(url);
                break;
            }
            case "SubstituteProducts": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=substituteproducts`;
                await this.populateFromUrl(url);
                break;
            }
            case "FamilyGroup": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=familygroup`;
                await this.populateFromUrl(url);
                break;
            }
            case "CoupleGroup": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=couplegroup`;
                await this.populateFromUrl(url);
                break;
            }
            case "GroupCostumes": {
                const url = `${Shopify.routes.root}products/${productHandle}?view=groupcostumes`;
                await this.populateFromUrl(url);
                break;
            }
        }
    }
}

class SmiffysAdditionalProductsPopup extends HTMLElement {

    modal = null;
    constructor() {
        super();
    }
    connectedCallback() {
        setTimeout(() => this.init());
    }

    init() {
        this.modal = this.querySelector('.modal')
        this.bindEvents();
    }

    close() {
        this.modal?.classList.remove('open');
        let productWrap = this.querySelector('.products-wrapper');
        productWrap.classList.remove('hydrated');
        document.querySelector('body')?.classList.remove('body-noscroll-class');
        this.setContent('');
    }
    setContent(content) {
        const productsWrapper = this.modal.querySelector('.products-wrapper');
        productsWrapper.innerHTML = content;
        if (content && content.length) {
            productsWrapper.classList.add('hydrated');
        } else {
            productsWrapper.classList.remove('hydrated');
        }
    }
    open(status) {
        this.modal?.classList.add('open');
        this.setStatus(status);
        document.querySelector('body')?.classList.add('body-noscroll-class');
    }
    setStatus(status) {
        let statusDiv = this.modal?.querySelector('.modal-status');
        if (statusDiv) {
            statusDiv.innerHTML = status;
        }
    }

    bindEvents() {
        window.onclick = (event) => {
            if (event.target == this.modal) {
                this.close();
            }
        };
        this.querySelector(".close")?.addEventListener('click', () => this.close());
    }
}

(() => {    
    window.smiffysAdditionalProductsPopupHelper = new SmiffysAdditionalProductsPopupHelper();
    window.customElements.define("smiffys-additional-products-popup", SmiffysAdditionalProductsPopup);
    window.smiffysAdditionalProductsPopupModal = document.querySelector('smiffys-additional-products-popup');
})()